var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "suba-d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.128,
    height: 36.472,
    viewBox: "0 0 64.128 36.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M304.61,571.064a11,11,0,0,1,7.119,2.266l-2.4,3.338a8.764,8.764,0,0,0-4.845-1.681c-1.162,0-1.73.487-1.73,1.1v.048c0,.78.593,1.121,2.991,1.657,3.982.853,6.452,2.12,6.452,5.311v.048a4.974,4.974,0,0,1-1.839,4.016h6.5c-1.636-1.267-2.559-3.321-2.559-6.233v-9.576h4.87v9.477c0,2.461,1.261,3.63,3.189,3.63s3.189-1.121,3.189-3.508v-9.6h4.87v9.453c0,3-.947,5.082-2.6,6.355h5.447V571.356h8.875a6.436,6.436,0,0,1,4.722,1.535,3.714,3.714,0,0,1,1.112,2.753v.049a3.951,3.951,0,0,1-2.669,3.8c2.1.682,3.436,1.852,3.436,4.166v.049A4.07,4.07,0,0,1,347,587.163h3.089l6.832-15.929h4.622l3.321,7.744V560.31H300.82v11.566A8.386,8.386,0,0,1,304.61,571.064Z",
    transform: "translate(-300.735 -560.31)",
    fill: "#a1a1a1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M1547.83,930.448h3.881l-1.928-4.848Z",
    transform: "translate(-1491.325 -909.248)",
    fill: "#a1a1a1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M1500.55,1115.868h8.149l-.744-1.8h-6.675Z",
    transform: "translate(-1446.184 -1089.258)",
    fill: "#a1a1a1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M1121.1,1031.053h3.71c1.459,0,2.3-.56,2.3-1.559v-.049c0-.925-.742-1.534-2.348-1.534H1121.1Z",
    transform: "translate(-1083.902 -1006.967)",
    fill: "#a1a1a1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M1126.389,889.951V889.9c0-.925-.741-1.462-2.175-1.462H1121.1v3h3.016C1125.575,891.437,1126.389,890.95,1126.389,889.951Z",
    transform: "translate(-1083.902 -873.743)",
    fill: "#a1a1a1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M307.353,1016.506v-.048c0-.707-.568-1.1-2.917-1.632a18.681,18.681,0,0,1-3.616-1.1v2.641a8.7,8.7,0,0,0,4.556,1.315C306.661,1017.676,307.353,1017.237,307.353,1016.506Z",
    transform: "translate(-300.735 -993.418)",
    fill: "#a1a1a1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M302.257,1232.76a3.265,3.265,0,0,1-3.317-3.327v-.018a3.287,3.287,0,0,1,3.372-3.345,3.336,3.336,0,0,1,2.55,1l-.9,1.045a2.384,2.384,0,0,0-1.654-.73,1.916,1.916,0,0,0-1.875,2.014v.019a1.921,1.921,0,0,0,1.875,2.033,2.334,2.334,0,0,0,1.7-.758l.9.915A3.306,3.306,0,0,1,302.257,1232.76Z",
    transform: "translate(-298.94 -1196.287)",
    fill: "#a1a1a1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M534.67,1233.985l-.591-1.451h-2.737l-.592,1.451H529.3l2.772-6.515h1.312l2.772,6.515Zm-1.959-4.805-.859,2.1h1.719Z",
    transform: "translate(-518.878 -1197.624)",
    fill: "#a1a1a1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M790.964,1233h-1.082v1.94H788.46v-6.47H791.1a2.215,2.215,0,0,1,2.476,2.236v.019C793.579,1232.224,792.415,1233,790.964,1233Zm1.173-2.262c0-.637-.443-.979-1.155-.979h-1.1v1.977h1.128a1,1,0,0,0,1.127-.979Z",
    transform: "translate(-766.312 -1198.579)",
    fill: "#a1a1a1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M1011.88,1234.94v-6.47h1.423v6.47Z",
    transform: "translate(-979.623 -1198.579)",
    fill: "#a1a1a1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M1157.821,1229.822v5.158H1156.4v-5.158h-1.968v-1.312h5.359v1.312Z",
    transform: "translate(-1115.724 -1198.617)",
    fill: "#a1a1a1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M1357.307,1233.985l-.591-1.451h-2.735l-.591,1.451h-1.45l2.772-6.515h1.312l2.772,6.515Zm-1.958-4.805-.86,2.1h1.719Z",
    transform: "translate(-1304.298 -1197.624)",
    fill: "#a1a1a1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M1611.08,1234.94v-6.47h1.423v5.175h3.225v1.294Z",
    transform: "translate(-1551.713 -1198.579)",
    fill: "#a1a1a1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.aa08340506a18f40eab820e697303e06.svg";
export { ForwardRef as ReactComponent };